import styled from "styled-components";

export const Container = styled.div`
  min-height: 12rem;
  background: var(--gray);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    cursor: pointer;
  }
`;
